import { Box, Typography } from '@mui/material'
import { Link } from 'elements/navigation'

export const IntegrationDetailsItem = ({
  title,
  value,
  isLink,
}: {
  title: string
  value: string
  isLink?: boolean
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="caption2" fontWeight={600} mb={0.5}>
        {title}
      </Typography>

      {isLink ? (
        <Link
          to={value}
          sx={{
            color: 'info.main',
            fontSize: 'caption1',
          }}
        >
          {value}
        </Link>
      ) : (
        <Typography variant="caption1" width={324}>
          {value}
        </Typography>
      )}
    </Box>
  )
}
